import React from 'react'
import PropTypes from 'prop-types'

import { Box, LoadingBubbles, StatusBadge } from '@campaignhub/suit-theme'

const MutationStatus = ({ isMutating }) => (
  <Box display="block" width="auto" textAlign="end" height={20}>
    {isMutating
      ? <LoadingBubbles color="rgba(0, 0, 0, 0.15)" style={{ flexShrink: 0 }} />
      : <StatusBadge color="#43ac6a" ghost text="Updated" />}
  </Box>
)

MutationStatus.propTypes = {
  isMutating: PropTypes.bool,
}

export default MutationStatus
